import React, { useState, useRef } from 'react';
import { Box } from '@mui/material';
import * as styles from './styles';

function ScheduleList({ children }) {
    const [isScrolling, setIsScrolling] = useState(false);
    const timeoutRef = useRef(null);

    function handleScroll() {
        setIsScrolling(true);
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => setIsScrolling(false), 1000);
    }

    return (
        <Box
            onScroll={handleScroll}
            sx={{
                ...styles.scheduleList,
                '&::-webkit-scrollbar-thumb': {
                    background: isScrolling ? 'rgba(187,188,188,0.35)' : 'transparent',
                    borderRadius: '4px',
                    transition: isScrolling ? 'background 0.1s ease' : 'background 0.6s ease',
                },
            }}
        >
            {children}
        </Box>
    );
}

export default ScheduleList;
